import { DomainBase } from "./DomainBase";

export  class AccGroup extends DomainBase { 
     constructor() { 
      super();
           this.Name = '';  
             this.ParentGroupID = '';   
              this.ShowDetailsInFinalAccounts = false; 
             }}